export const scoreMeta = (scores: any[] = []) => ({
  goal: scores[0] ?? "-",
  half: scores[1] ?? "-",
  red: Number(scores[2] || 0),
  yellow: Number(scores[3] || 0),
  corner: Number(scores[4] ?? -1),
  extra: Number(scores[5] || 0),
  penalty: Number(scores[6] || 0),
});

export const isNotStartedInfo = (info: any): boolean =>
  Number(info?.statusId) === 1;

export const displayScoreMeta = (info: any, side: "home" | "away") => {
  const scores = side === "home" ? info?.homeScores : info?.awayScores;
  const meta = scoreMeta(scores);
  if (!isNotStartedInfo(info)) return meta;
  return {
    ...meta,
    goal: side === "home" ? "VS" : "",
    half: "-",
    corner: -1,
  };
};

export const formatCorners = (
  homeScores: any[] = [],
  awayScores: any[] = [],
): string => {
  const home = scoreMeta(homeScores);
  const away = scoreMeta(awayScores);
  return home.corner >= 0 && away.corner >= 0
    ? `${home.corner} - ${away.corner}`
    : "-";
};

export const displayHalfScore = (info: any): string =>
  isNotStartedInfo(info)
    ? "-"
    : `${displayScoreMeta(info, "home").half} - ${displayScoreMeta(info, "away").half}`;

export const displayCorners = (info: any): string => {
  if (isNotStartedInfo(info)) return "-";
  return formatCorners(info?.homeScores, info?.awayScores);
};

export const winnerMarkers = (
  homeScores: any[] = [],
  awayScores: any[] = [],
) => {
  const home = scoreMeta(homeScores);
  const away = scoreMeta(awayScores);
  const homeWinsExtra = home.extra > away.extra;
  const awayWinsExtra = away.extra > home.extra;
  const homeWinsPenalty =
    !homeWinsExtra && !awayWinsExtra && home.penalty > away.penalty;
  const awayWinsPenalty =
    !homeWinsExtra && !awayWinsExtra && away.penalty > home.penalty;
  return {
    home: homeWinsExtra || homeWinsPenalty,
    away: awayWinsExtra || awayWinsPenalty,
  };
};

export const winnerTooltips = (
  homeScores: any[] = [],
  awayScores: any[] = [],
) => {
  const home = scoreMeta(homeScores);
  const away = scoreMeta(awayScores);
  if (home.extra > away.extra)
    return { home: `Hiệp phụ: ${home.extra} - ${away.extra}`, away: "" };
  if (away.extra > home.extra)
    return { home: "", away: `Hiệp phụ: ${home.extra} - ${away.extra}` };
  if (home.penalty > away.penalty)
    return { home: `Luân lưu: ${home.penalty} - ${away.penalty}`, away: "" };
  if (away.penalty > home.penalty)
    return { home: "", away: `Luân lưu: ${home.penalty} - ${away.penalty}` };
  return { home: "", away: "" };
};

export const mobileExtraResultText = (
  info: any,
  homeName: string,
  awayName: string,
): string => {
  if (isNotStartedInfo(info)) return "";

  const home = scoreMeta(info?.homeScores);
  const away = scoreMeta(info?.awayScores);
  const hasExtra = home.extra > 0 || away.extra > 0;
  const hasPenalty = home.penalty > 0 || away.penalty > 0;
  if (!hasExtra && !hasPenalty) return "";

  const parts: string[] = [];
  if (hasExtra) parts.push(`Hiệp phụ: ${home.extra} : ${away.extra}`);
  if (hasPenalty)
    parts.push(`Tỷ số Penalty: ${home.penalty} : ${away.penalty}`);

  const homeWinsExtra = home.extra > away.extra;
  const awayWinsExtra = away.extra > home.extra;
  const homeWinsPenalty =
    !homeWinsExtra && !awayWinsExtra && home.penalty > away.penalty;
  const awayWinsPenalty =
    !homeWinsExtra && !awayWinsExtra && away.penalty > home.penalty;
  const winnerName =
    homeWinsExtra || homeWinsPenalty
      ? homeName
      : awayWinsExtra || awayWinsPenalty
        ? awayName
        : "";
  if (winnerName) parts.push(`${winnerName} thắng`);

  return parts.join(" - ");
};
